'use client';

import { c as _c } from "react/compiler-runtime";
import { AddToCompareCheckboxWithTooltip } from 'src/features/compare-bar/CompareBar/AddToCompareCheckboxWithTooltip';
import { useCompareCheckboxAnalyticsEvents } from './hooks';
export function CompareCheckbox(t0) {
  const $ = _c(4);
  const {
    creditCardOfferId
  } = t0;
  const checkboxAnalyticsEvents = useCompareCheckboxAnalyticsEvents();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      xs: undefined,
      md: "32px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== checkboxAnalyticsEvents || $[2] !== creditCardOfferId) {
    t2 = <AddToCompareCheckboxWithTooltip creditCardOfferId={creditCardOfferId} fireAnalyticsEvents={checkboxAnalyticsEvents} variant="design2" height={t1} display="flex" alignItems="center" />;
    $[1] = checkboxAnalyticsEvents;
    $[2] = creditCardOfferId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}